import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddIcCallIcon from "@mui/icons-material/AddIcCall";
import AirlineSeatIndividualSuiteIcon from "@mui/icons-material/AirlineSeatIndividualSuite";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HistoryIcon from "@mui/icons-material/History";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import React from "react";

export const allRoutePathsFunc = (isSignOrder = false) => {
  return [
    {
      text: "DASHBOARD",
      path: "/dashboard",
      tabName: "dashboard",
      iconComponent: <DashboardIcon />,
    },
    {
      text: "PATIENTS",
      path: "/patients",
      tabName: "patients",
      iconComponent: <AirlineSeatIndividualSuiteIcon />,
    },
    {
      text: "Scheduler",
      path: "/scheduler",
      tabName: "schedule",
      iconComponent: <CalendarMonthIcon />,
    },
    {
      text: "Scheduler",
      path: "/scheduler",
      tabName: "viewSchedule",
      iconComponent: <CalendarMonthIcon />,
    },
    {
      text: "REPORTS",
      path: "/reports",
      tabName: "reports",
      iconComponent: <AssessmentIcon />,
    },
    {
      text: "ADMIN",
      path: "/admin",
      tabName: "admin",
      iconComponent: <ManageAccountsIcon />,
    },
    {
      text: "PROFILE",
      path: `${isSignOrder ? "/physician-profile" : "/profile"}`,
      tabName: "profSettings",
      iconComponent: <AccountCircleIcon />,
    },
  ];
};

export const allSubRoutes = [
  {
    text: (
      <React.Fragment>
        Patients{" "}
        <ArrowForwardIcon fontSize="small" sx={{ margin: "0px 6px" }} /> New
        Order
      </React.Fragment>
    ),
    path: "/new-order",
  },
  {
    text: (
      <React.Fragment>
        Patients{" "}
        <ArrowForwardIcon fontSize="small" sx={{ margin: "0px 6px" }} /> New
        Survey
      </React.Fragment>
    ),
    path: "/new-survey",
  },
  {
    text: (
      <React.Fragment>
        Patients{" "}
        <ArrowForwardIcon fontSize="small" sx={{ margin: "0px 6px" }} /> Patient
        View
      </React.Fragment>
    ),
    path: "/patient-view",
  },
  {
    text: (
      <React.Fragment>
        Patients{" "}
        <ArrowForwardIcon fontSize="small" sx={{ margin: "0px 6px" }} /> Survey
      </React.Fragment>
    ),
    path: "/survey-view",
  },
  {
    text: (
      <React.Fragment>
        Patients{" "}
        <ArrowForwardIcon fontSize="small" sx={{ margin: "0px 6px" }} /> Order
      </React.Fragment>
    ),
    path: "/order-view",
  },
  {
    text: (
      <React.Fragment>
        Patients{" "}
        <ArrowForwardIcon fontSize="small" sx={{ margin: "0px 6px" }} /> DME
        Order
      </React.Fragment>
    ),
    path: "/dme-order",
  },
];

export const patientPortalRoutes = [
  {
    text: "Portal Home",
    path: "/patient-portal",
    tabName: "patient-portal",
    iconComponent: <DashboardIcon />,
  },
  {
    text: "PROFILE",
    path: "/patient-profile",
    tabName: "patient-profile",
    iconComponent: <AccountCircleIcon />,
  },
  // {
  //   text: "Scheduling",
  //   path: "/scheduling",
  //   tabName: "scheduling",
  //   iconComponent: <CalendarMonthIcon />,
  // },
  {
    text: "PAST VISITS",
    path: "/patient-past-visits",
    tabName: "patient-past-visits",
    iconComponent: <HistoryIcon />,
  },
  {
    text: "CONTACT US",
    path: "/contact-us",
    tabName: "contact-us",
    iconComponent: <AddIcCallIcon />,
  },
];

export const AUTH_ROUTES = {
  AUTH_LOGIN: "authlogin",

  SIGNIN_INITIAL_PROVIDER: "signin-initial-provider",
  SIGNIN_INITIAL_PATIENT: "signin-initial-patient",

  SIGNIN: "signin",
  SIGNIN_LANDING: "signin-landing",
  SIGNIN_AS_PATIENT: "signin-as-patient",
  PATIENT_AGREEMENT: "patient-agreement",

  USER_AGREEMENT: "user-agreement",

  SETUP_MFA: "setup-mfa",

  FORGOT_PASSWORD: "forgot-password",

  NOT_FOUND: "*",

  SLEEPNAVIGATOR_URL: process.env.REACT_APP_SIGNIN_LANDING_URL,
};

export const PROVIDER_PORTAL_ROUTES = {
  ROOT: "",

  DASHBOARD: "dashboard",
  PROFILE: "profile",
  PATIENTS: "patients",
  SCHEDULER: "scheduler",
  REPORTS: "reports",
  ADMIN: "admin",

  PHYSICIAN_PROFILE: "physician-profile",

  // Orders & Surveys
  NEW_SURVEY: "new-survey",
  NEW_ORDER: "new-order",

  // Views
  PATIENT_VIEW: "patient-view",
  USER_VIEW: "user-view",
  GROUP_VIEW: "group-view",
  ROLE_VIEW: "role-view",
  LOCATION_VIEW: "location-view",
  INSURANCE_VIEW: "insurance-view",

  // Actions
  DELETE_RECORD: "delete-record",
  ADD_CARRIER: "add-carrier",

  // Questionnaires
  STOP_BANG: "stop-bang",
  BERLIN_QUESTIONNAIRE: "berlin-questionaire",
  SATISFACTION_SURVEY: "satisfaction-survey",
  QUALITY_IMPROVEMENT_SURVEY: "quality-improvement-survey",
  EPWORTH_SLEEPINESS_SCALE: "epworth-sleepiness-scale",

  // Other views
  INTERP_PHYS_VIEW: "interp-phys-view",
  SURVEY_VIEW: "survey-view",
  ORDER_VIEW: "order-view",

  // Referrals
  ADD_PATIENT_BY_SLEEP_ORDER_UPLOAD: "add-patient-by-sleep-order",
  ADD_PATIENT_BY_DME_ORDER_UPLOAD: "add-patient-by-dme-order",
  SLEEP_REFERRAL_VIEW: "sleep-referral-view",
  DME_REFERRAL_VIEW: "dme-referral-view",

  INVALID_REFERRAL_VIEW: "invalid-referral-view",

  // Example
  EXAMPLE: "example",

  // DME
  DME_ORDER: "dme-order",

  // Payments
  MAKE_PAYMENT: "make-payment",
  CREDIT_CARD_PAYMENT: "credit-card-payment",
};

export const PATIENT_PORTAL_ROUTES = {
  ROOT: "",

  HOME: "patient-portal",
  PROFILE: "patient-profile",
  SCHEDULER: "scheduler",
  PAST_VISITS: "patient-past-visits",
  CONTACT_US: "contact-us",

  // Payments
  MAKE_PAYMENT: "make-payment",
  CREDIT_CARD_PAYMENT: "credit-card-payment",
};
